import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectItem } from 'primeng/api/selectitem';
import { VerificacionObraService } from 'src/app/datos/verificacion-obra.service';
import { FormValidation, HttpSession, Util } from 'src/app/libs/ruvpp-angular2-comun/index';
import { ServicioIndicadorCarga } from 'src/app/libs/ruvpp-angular2-comun/indicador-carga';
import { JsonResponse } from 'src/app/libs/ruvpp-angular2-comun/modelo/Index';
import { ServicioAlertas } from 'src/app/libs/ruvpp-angular2-comun/ServicioAlertas';
import { AvanceObraDTO, CatalogoProspectoVenta, CatalogoTipoAccion, InputReporte, OutputReporteAvanceObra, OutputVistaInformacionGeneral, PeriodoAvanceObra, PorcentajesConceptosGeneralesObra, SeguridadSalida } from 'src/app/modelo';
import { DatePipe } from '@angular/common';

//@Autor: Ernesto López Hdez
@Component({
    selector: 'app-avance-obra',
    templateUrl: './avance-obra.component.html',
    //styleUrls: ['./avance-obra.component.css']
})
export class AvanceObraComponent implements OnInit {


    public user: SeguridadSalida;
    public usuario: string;
    public verificador: string;

    //Forma

    public avanceObra: OutputReporteAvanceObra;
    public entity: AvanceObraDTO;
    public vistaInformacionGeneral: OutputVistaInformacionGeneral;
    public periodoAvanceObra: PeriodoAvanceObra;
    public reporteIntermedio: boolean = false;
    public listNoPeriodo: SelectItem[];


    //Validaciones

    public periodoDel_MensajeError: FormValidation = new FormValidation(null);
    public periodoAl_MensajeError: FormValidation = new FormValidation(null);
    public disabled_BtnGuardar: boolean;


    /**
     * 
     * @param servicioIndicadorCarga
     * @param servicioAlertas
     * @param service
     * @param _router
     * @param spinner
     */
    constructor(private servicioIndicadorCarga: ServicioIndicadorCarga, private servicioAlertas: ServicioAlertas, private service: VerificacionObraService, private _router: Router, private spinner: NgxSpinnerService) {

        this.user = HttpSession.getAttribute('USER');

        if (this.user != null) {
            this.usuario = `${HttpSession.getAttribute('USER_NAME')}`;
            this.verificador = `${HttpSession.getAttribute('USER_VERIFICADOR')}`;
        }

        this.vistaInformacionGeneral = HttpSession.getAttribute('ENTITY');

        console.log('AvanceObraComponent -->> ', new Date());

    }

    /**
     * 
     */
    async ngOnInit() {
        this.avanceObra = <OutputReporteAvanceObra>{
            periodoAvanceObra: <PeriodoAvanceObra>{},
            porcentajesConceptosGeneralesObra: <PorcentajesConceptosGeneralesObra>{},
            listaAvanceObra: [],
            listCatalogoTipoAccion: [],
            listCatalogoProspectoVenta: []
        };
    }

    /**
     * 
     */
    public async init() {

        await this.loading();

        //this.avanceObra.periodoAvanceObra.fechaDel = HttpSession.addDays(new Date(), -1);
        //this.avanceObra.periodoAvanceObra.fechaAl = HttpSession.addDays(this.avanceObra.periodoAvanceObra.fechaDel, 15);
    }


    /**
     * 
     */
    private async loading() {

        let dato: InputReporte = <InputReporte>{ idOrdenVerificacion: this.vistaInformacionGeneral.ordenVerificacion };

        let resultado: JsonResponse<OutputReporteAvanceObra> = await this.service.ObtenerReporteAvanceObra(dato).toPromise();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            this.avanceObra = resultado.model;
            //this.avanceObra.claveEstatus = 0;

            if (this.avanceObra.periodoAvanceObra.fechaDel_SF != null) {
                this.avanceObra.periodoAvanceObra.fechaDel_SF = new Date(this.avanceObra.periodoAvanceObra.fechaDel_SF);
            }

            if (this.avanceObra.periodoAvanceObra.fechaAl_SF != null) {
                this.avanceObra.periodoAvanceObra.fechaAl_SF = new Date(this.avanceObra.periodoAvanceObra.fechaAl_SF);
            }

            this.periodoAvanceObra = Util.clone<PeriodoAvanceObra>(this.avanceObra.periodoAvanceObra);

            if (this.periodoAvanceObra.fechaDel_SF != null) {
                this.periodoAvanceObra.fechaDel_SF = new Date(this.periodoAvanceObra.fechaDel_SF);
            }

            if (this.periodoAvanceObra.fechaAl_SF != null) {
                this.periodoAvanceObra.fechaAl_SF = new Date(this.periodoAvanceObra.fechaAl_SF);
            }

            this.avanceObra.porcentajesConceptosGeneralesObra.porcentajeAvanceUrbanizacion_TMP = this.avanceObra.porcentajesConceptosGeneralesObra.porcentajeAvanceUrbanizacion;

            this.avanceObra.porcentajesConceptosGeneralesObra.porcentajeAvanceInfraestructura_TMP = this.avanceObra.porcentajesConceptosGeneralesObra.porcentajeAvanceInfraestructura;

            this.avanceObra.porcentajesConceptosGeneralesObra.porcentajeAvanceEquipamiento_TMP = this.avanceObra.porcentajesConceptosGeneralesObra.porcentajeAvanceEquipamiento;

            if (this.avanceObra.listaAvanceObra != null && this.avanceObra.listaAvanceObra.length > 0) {

                this.entity = this.avanceObra.listaAvanceObra[0];

                for (let row of this.avanceObra.listaAvanceObra) {
                    row.porcentajeAvance_TMP = row.porcentajeAvance;
                    row.cumpleTipologia_TMP = row.cumpleTipologia;
                }

                this.avanceObra.periodoAvanceObra.valPeriodoReporte = this.avanceObra.periodoAvanceObra.periodoReporte;

                this.avanceObra.periodoAvanceObra.reporteIntermedio_TMP = this.avanceObra.periodoAvanceObra.reporteIntermedio;

                this.avanceObra.periodoAvanceObra.verReporteIntermedio_TMP = this.avanceObra.periodoAvanceObra.verReporteIntermedio;

                this.onChangeIsReporteIntermedio(true);

                console.log('this.reporteIntermedio -->> ', this.reporteIntermedio)

            }

        } else {
            console.error(`---------------------------------------------------------------------------------------------------------------------`);
            console.error(`Error: `, resultado);
        }
    }

    /**
     * 
     * @param entity
     */
    public onRowSelect(entity: any): void {

        let object: AvanceObraDTO = this.avanceObra.listaAvanceObra.filter(row => row.indentificadorVivienda == entity.indentificadorVivienda)[0];

        this.entity = object;
    }

    /**
     * 
     * @param entity
     */
    public onRowUnselect(entity: any): void {

    }

    /**
    * 
    * @param entity
    * @param value
    */
    public onChangeCumpleTipologia(entity: any, value: number) {
        entity.cumpleTipologia = value;
    }

    /**
    * 
    * @param entity
    * @param value
    */
    public onChangeCumpleSuperficieTotalHabitable(entity: any, value: number) {
        //entity.cumpleSuperficieTotalHabitable = value;
        entity.cumpleSuperficieHabitable = value;
    }

    /**
     * 
     */
    public getDateSpanish(): any {
        return Util.getDateSpanish();
    }

    /**
     * 
     */
    public Regresar(): void {
        Util.forward(this._router, 'VistaInformacionGeneralComponent');
    }

    /**
     * 
     */
    private async getPorcentaje() {

        let promedioConceptosGenerales: number = ((this.avanceObra.porcentajesConceptosGeneralesObra.porcentajeAvanceUrbanizacion + this.avanceObra.porcentajesConceptosGeneralesObra.porcentajeAvanceInfraestructura + this.avanceObra.porcentajesConceptosGeneralesObra.porcentajeAvanceEquipamiento) / 3) * 0.15;

        let promedioAvanceObra: number = 0;

        for (let row of this.avanceObra.listaAvanceObra) {

            promedioAvanceObra += row.porcentajeAvance;

            row.numeroReporte = this.avanceObra.periodoAvanceObra.periodoReporte;
        }

        promedioAvanceObra = (promedioAvanceObra / this.avanceObra.listaAvanceObra.length) * 0.85;

        let porcentajeAvance: number = promedioConceptosGenerales + promedioAvanceObra;

        this.avanceObra.porcentajeAvance = Math.trunc(porcentajeAvance);

        this.avanceObra.idOrdenVerificacion = this.vistaInformacionGeneral.ordenVerificacion;

    }

    /**
    * 
    */
    public validarFormumlario(): boolean {

        var error = false;

        this.periodoDel_MensajeError = this.actualizarErrores('periodoDel');

        if (this.periodoDel_MensajeError.error == true) {
            error = true;
        }

        this.periodoAl_MensajeError = this.actualizarErrores('periodoAl');

        if (this.periodoAl_MensajeError.error == true) {
            error = true;
        }

        return error;
    }

    /**
     * 
     * @param tipo
     */
    public actualizarErrores(tipo: string): FormValidation {

        let error: FormValidation = null;

        switch (tipo) {

            case 'periodoDel':

                this.periodoDel_MensajeError = new FormValidation(null);

                if (this.avanceObra.periodoAvanceObra.fechaDel_SF == null) {
                    this.periodoDel_MensajeError = new FormValidation(null).requered('La Fecha periodo inicial es obligatorio');
                } else {

                    if (this.avanceObra.periodoAvanceObra.fechaDel_SF != null && this.reporteIntermedio == false) {

                        if (this.avanceObra.periodoAvanceObra.valPeriodoReporte == 1) {

                            if (this.avanceObra.periodoAvanceObra.fechaAl_SF != null && (this.avanceObra.periodoAvanceObra.fechaDel_SF >= this.avanceObra.periodoAvanceObra.fechaAl_SF)) {
                                this.periodoDel_MensajeError = new FormValidation(null).requered('La Fecha periodo inicial debe ser menor a la Fecha periodo final');
                            }

                        } else {

                            if (this.avanceObra.periodoAvanceObra.fechaDel_SF <= this.periodoAvanceObra.fechaAl_SF) {
                                this.periodoDel_MensajeError = new FormValidation(null).requered('La Fecha periodo inicial debe ser mayor a la Fecha periodo final del periodo anterior');
                            }

                        }

                    }

                }

                error = this.periodoDel_MensajeError;

                break;

            case 'periodoAl':

                this.periodoAl_MensajeError = new FormValidation(null);

                if (this.avanceObra.periodoAvanceObra.fechaAl_SF == null) {
                    this.periodoAl_MensajeError = new FormValidation(null).requered('La Fecha periodo final es obligatorio');
                } else {

                    if (this.avanceObra.periodoAvanceObra.fechaAl_SF != null && this.reporteIntermedio == false) {

                        let validacion: boolean = true;

                        if (this.avanceObra.periodoAvanceObra.fechaAl_SF <= this.avanceObra.periodoAvanceObra.fechaDel_SF) {
                            this.periodoAl_MensajeError = new FormValidation(null).requered('La Fecha periodo final debe ser mayor a la Fecha periodo inicial');
                            validacion = false;
                        }

                        if (validacion && this.avanceObra.periodoAvanceObra.valPeriodoReporte > 1) {

                            const periodoAl = moment(this.avanceObra.periodoAvanceObra.fechaAl_SF);

                            let diasDiferencia: number = periodoAl.diff(this.avanceObra.periodoAvanceObra.fechaDel_SF, 'days');

                            if (diasDiferencia < 10) {
                                this.periodoAl_MensajeError = new FormValidation(null).requered('Entre la fecha periodo inicial y fecha periodo final, debe existir un intervalo de 10 días.');
                                validacion = false;
                            }
                        }
                    }

                }

                error = this.periodoAl_MensajeError;

                break;
        }

        return error;

    }

    /**
    * 
    */
    public async Guardar() {

        if (!this.validarFormumlario()) {

            var datePipe = new DatePipe('en-US');

            await this.getPorcentaje();

            this.avanceObra.periodoAvanceObra.reporteIntermedio = this.reporteIntermedio;

            this.avanceObra.periodoAvanceObra.fechaDel = datePipe.transform(this.avanceObra.periodoAvanceObra.fechaDel_SF, "dd/MM/yyyy");

            this.avanceObra.periodoAvanceObra.fechaAl = datePipe.transform(this.avanceObra.periodoAvanceObra.fechaAl_SF, "dd/MM/yyyy");

            let json = JSON.stringify(this.avanceObra);

            let avanceObra: OutputReporteAvanceObra = JSON.parse(json);

            avanceObra.listCatalogoTipoAccion = null;

            avanceObra.listCatalogoProspectoVenta = null;

            avanceObra.periodoAvanceObra.periodoReporte = this.avanceObra.periodoAvanceObra.valPeriodoReporte;

            Util.showLoadingMessage(this.spinner, `Guardando información de reporte de avance de obra ...`);

            let resultado: JsonResponse<boolean> = await this.service.GuardarReporteAvanceObra(avanceObra).toPromise();

            Util.hideLoadingMessage();

            if (resultado != null && resultado.code == 200) {

                let respuesta: boolean = resultado.model;

                if (respuesta == true) {

                    var strCallback = (): void => {
                        this.Regresar();
                    }

                    let value = Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Información guardada correctamente ...', 'success', false, strCallback);
                }

            } else {
                Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Error al intentar guardar la información ...', 'warning');
                console.error('Guardar() -->> ', resultado.message);
            }
        } else {
            Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Existen datos incorrectos, favor de corregir...', 'warning');
        }

    }

    /**
     * 
     * @param index
     */
    private getListNoPeriodo(index: number | null): SelectItem[] {

        let lista: SelectItem[] = [];

        if (index == null || index == 0) {
            index = 1;
        }

        let inicio: number = index;

        let final: number = 100; //index;

        for (let x = inicio; x <= final; x++) {
            lista.push({ label: x + '', value: x })
        }

        return lista;
    }

    /**
     * 
     */
    public getListProspectoVenta(): SelectItem[] {

        let lista: SelectItem[] = [];

        for (let row of this.avanceObra.listCatalogoProspectoVenta) {
            lista.push({ label: row.descripcion, value: row.id })
        }

        return lista;
    }

    /**
     * 
     * @param idProspectoVenta
     */
    public getProspectoVenta(idProspectoVenta): string {

        let value: string = 'Ninguno';

        let lista: CatalogoProspectoVenta[] = this.avanceObra.listCatalogoProspectoVenta.filter(row => row.id == idProspectoVenta);

        if (lista != null && lista.length > 0) {
            value = lista[0].descripcion;
        }

        return value;
    }

    /**
     * 
     */
    public getListTipoAccion(): SelectItem[] {

        let lista: SelectItem[] = [];

        for (let row of this.avanceObra.listCatalogoTipoAccion) {
            lista.push({ label: row.descripcion, value: row.id })
        }

        return lista;
    }

    /**
     * 
     * @param idTipoAccion
     */
    public getTipoAccion(idTipoAccion): string {

        let value: string = 'Ninguno';

        let lista: CatalogoTipoAccion[] = this.avanceObra.listCatalogoTipoAccion.filter(row => row.id == idTipoAccion);

        if (lista != null && lista.length > 0) {
            value = lista[0].descripcion;
        }

        return value;
    }

    /**
     * 
     */
    public getListTipologia(): SelectItem[] {

        let lista: SelectItem[] = [];

        for (let x = 21; x <= 30; x++) {
            lista.push({ label: x + '', value: x })
        }

        return lista;
    }

    /**
     * 
     * @param index
     */
    public getListPorcentaje(index: number): SelectItem[] {

        let lista: SelectItem[] = [];

        for (let x = index; x <= 100; x++) {
            lista.push({ label: x + '', value: x })
        }

        return lista;
    }

    /**
     * 
     * @param inicio
     */
    public onChangeIsReporteIntermedio(inicio: boolean): void {

        //if (inicio == true) {
        //    this.avanceObra.periodoAvanceObra.valPeriodoReporte++;
        //}

        if (this.avanceObra.periodoAvanceObra.periodoReporte == null || this.avanceObra.periodoAvanceObra.periodoReporte == 0) {
            this.avanceObra.periodoAvanceObra.valPeriodoReporte = 1;
        }

        this.reporteIntermedio = false;

        this.avanceObra.periodoAvanceObra.verReporteIntermedio = false;

        if (inicio == true) {
            this.avanceObra.periodoAvanceObra.reporteIntermedio = false;
        }

        if (this.avanceObra.periodoAvanceObra.periodoReporte == this.avanceObra.periodoAvanceObra.valPeriodoReporte) {
            this.reporteIntermedio = true;
            this.avanceObra.periodoAvanceObra.verReporteIntermedio = true;
        }

        if (this.avanceObra.periodoAvanceObra.periodoReporte < this.avanceObra.periodoAvanceObra.valPeriodoReporte) {
            this.avanceObra.periodoAvanceObra.reporteIntermedio = false;
        }

        this.listNoPeriodo = this.getListNoPeriodo(this.avanceObra.periodoAvanceObra.periodoReporte);

        if (this.reporteIntermedio == true) {
            this.periodoDel_MensajeError = new FormValidation(null);
            this.periodoAl_MensajeError = new FormValidation(null);
            this.avanceObra.periodoAvanceObra.fechaDel_SF = new Date(this.avanceObra.periodoAvanceObra.fechaDel_SF);
            this.avanceObra.periodoAvanceObra.fechaAl_SF = new Date(this.avanceObra.periodoAvanceObra.fechaAl_SF);
            this.avanceObra.periodoAvanceObra.valPeriodoReporte = this.periodoAvanceObra.periodoReporte;
        }

    }

    /**
     * 
     */
    public onChangePeriodo() {
        this.onChangeIsReporteIntermedio(false);
    }

    /**
     * 
     * @param entity
     * @param idOpcion
     */
    public getDisabled(entity: AvanceObraDTO, idOpcion: number | null): boolean {

        let resultado: boolean = false;

        resultado = this.getClaveEstatus();

        /*if (this.avanceObra.claveEstatus != 0) {
            resultado = true;
        }*/

        if (entity != null) {

            if (idOpcion != null) {

                switch (idOpcion) {

                    case 1:
                        {
                            if (entity.claveEstatus != 0) {
                                resultado = true;
                            }

                            if (entity.verObraNegra == false) {
                                resultado = true;
                            }
                        }
                        break;
                    case 2:
                        {
                            if (entity.claveEstatus != 0) {
                                resultado = true;
                            }

                            if (entity.verProspectoVenta == false) {
                                resultado = true;
                            }
                        }
                        break;
                    case 3:
                        {
                            if (entity.claveEstatus != 0) {
                                resultado = true;
                            }

                            if (entity.verIndicadorCalidad == false) {
                                resultado = true;
                            }
                        }
                        break;
                    case 4:
                        {
                            if (entity.claveEstatus != 0) {
                                resultado = true;
                            }

                            if (entity.verTipoAccion == false) {
                                resultado = true;
                            }
                        }
                        break;
                    case 5:
                        {
                            if (entity.claveEstatus != 0) {
                                resultado = true;
                            }

                            if (entity.verCumpleTipologia == false) {
                                resultado = true;
                            }

                            if (entity.cumpleTipologia_TMP == 1) {
                                resultado = true;
                            }
                        }
                        break;
                    case 6:
                        {
                            if (entity.claveEstatus != 0) {
                                resultado = true;
                            }

                            if (entity.verCumpleSuperficieHabitable == false) {
                                resultado = true;
                            }

                            //if (entity.cumpleTipologia_TMP == 1) {
                            //    resultado = true;
                            //}

                            if (entity.porcentajeAvance_TMP <= 50) {
                                resultado = true;
                            }
                        }
                        break;
                    case 7:
                        {
                            //porcentajeAvance
                            if (entity.claveEstatus != 0) {
                                resultado = true;
                            }
                        }
                        break;
                    case 8:
                        {
                            //superficieHabitable
                            if (entity.claveEstatus != 0) {
                                resultado = true;
                            }
                        }
                        break;
                    case 9:
                        {
                            //observaciones
                            if (entity.claveEstatus != 0) {
                                resultado = true;
                            }
                        }
                        break;

                }

            }

        }

        return resultado;
    }

    /**
     * 
     */
    public disabledGuardar(): boolean {

        let resultado: boolean = false;

        let claveEstatus: number = 0;

        resultado = this.getClaveEstatus();

        /*if (this.avanceObra.claveEstatus != 0) {
            resultado = true;
        }*/

        if (this.avanceObra.periodoAvanceObra.periodoReporte == this.avanceObra.periodoAvanceObra.valPeriodoReporte && this.avanceObra.periodoAvanceObra.reporteIntermedio == false) {
            resultado = true;
        }

        return resultado;

    }

    /**
     * 
     */
    private getClaveEstatus(): boolean {

        let disabledClaveEstatus: boolean = false;

        let numClaveEstatus: number = 0;

        for (let row of this.avanceObra.listaAvanceObra) {

            if (row.claveEstatus != 0) {
                numClaveEstatus++;
            }

        }

        if (numClaveEstatus == this.avanceObra.listaAvanceObra.length) {
            disabledClaveEstatus = true;
        }

        return disabledClaveEstatus;

    }


}
